// extracted by mini-css-extract-plugin
export default {"university_page":"University_university_page__HRp2l","university_item":"University_university_item__IuiyS"};